import { _ as _objectWithoutProperties, d as _objectSpread2, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-quantity__label-1-6-0{display:block;margin-bottom:12px;color:#444}@media (min-width:1200px){.hcr-quantity__label-1-6-0{margin-bottom:2px}}.hcr-quantity--inline-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.hcr-quantity--inline-1-6-0 .hcr-quantity__label-1-6-0{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;margin-bottom:0;font-size:16px;font-weight:700;line-height:22px}.hcr-quantity--inline-1-6-0 .hcr-quantity__label-1-6-0 small{display:block;font-size:14px;font-weight:300;line-height:17px}.hcr-quantity__picker-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-webkit-align-items:stretch;-ms-flex-align:stretch;align-items:stretch}.hcr-quantity__picker--active-1-6-0 .hcr-quantity__input-1-6-0{border:1px solid #757575}.hcr-quantity__picker--disabled-1-6-0 .hcr-quantity__button-1-6-0,.hcr-quantity__picker--disabled-1-6-0 .hcr-quantity__input-1-6-0{opacity:.5}.hcr-quantity__picker--error-1-6-0 .hcr-quantity__input-1-6-0{border:1px solid #ff5700}.hcr-quantity__input-1-6-0{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;font-weight:300;position:relative;width:100%;height:44px;padding:0 12px;border:1px solid #c8c8c8;border-radius:5px;background-color:#fff;color:#444;line-height:1.375em;text-overflow:ellipsis;-webkit-appearance:none;-moz-appearance:none;appearance:none;width:60px;text-align:center;-moz-appearance:textfield}@media (min-width:1200px){.hcr-quantity__input-1-6-0{height:36px}}.hcr-quantity__input-1-6-0::-webkit-input-placeholder{color:#757575;font-style:italic}.hcr-quantity__input-1-6-0::-moz-placeholder{color:#757575;font-style:italic}.hcr-quantity__input-1-6-0:-ms-input-placeholder{color:#757575;font-style:italic}.hcr-quantity__input-1-6-0::-ms-input-placeholder{color:#757575;font-style:italic}.hcr-quantity__input-1-6-0::placeholder{color:#757575;font-style:italic}.hcr-quantity__input-1-6-0::-webkit-inner-spin-button,.hcr-quantity__input-1-6-0::-webkit-outer-spin-button{margin:0;-webkit-appearance:none}.hcr-quantity__input-1-6-0:focus{border:1px solid #757575}.hcr-quantity__button-1-6-0{width:35px;padding:0;border:0;background:transparent;color:#8b8b8b;font-size:16px;cursor:pointer}.hcr-quantity__button-1-6-0:disabled,.hcr-quantity__button--disabled-1-6-0{cursor:not-allowed;opacity:.5}.hcr-quantity__button-1-6-0:after{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle}.hcr-quantity__button--minus-1-6-0{padding-right:12px}.hcr-quantity__button--minus-1-6-0:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M923.2 470.5H76.8a29.1 29.1 0 00-20.9 50 30.9 30.9 0 0020.9 8.6h846.4a29.5 29.5 0 0031.3-29.1 30 30 0 00-31.3-29.5z' fill='rgba(139, 139, 139, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;background-size:20px}.hcr-quantity__button--plus-1-6-0{padding-left:12px}.hcr-quantity__button--plus-1-6-0:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M529.5 923.2V529.5h393.7a29.5 29.5 0 0031.3-29.5 30 30 0 00-29.5-29.5H529.5V76.8A30 30 0 00500 45.5a29.1 29.1 0 00-20.9 8.6 30.9 30.9 0 00-8.6 20.9v393.6H76.8a29.1 29.1 0 00-20.9 50 30.9 30.9 0 0020.9 8.7h393.7v393.6a29.5 29.5 0 1058.6 0z' fill='rgba(139, 139, 139, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;background-size:20px}",
map:{"hcr-quantity__label":"hcr-quantity__label-1-6-0","hcr-quantity--inline":"hcr-quantity--inline-1-6-0","hcr-quantity__picker":"hcr-quantity__picker-1-6-0","hcr-quantity__picker--active":"hcr-quantity__picker--active-1-6-0","hcr-quantity__input":"hcr-quantity__input-1-6-0","hcr-quantity__picker--disabled":"hcr-quantity__picker--disabled-1-6-0","hcr-quantity__button":"hcr-quantity__button-1-6-0","hcr-quantity__picker--error":"hcr-quantity__picker--error-1-6-0","hcr-quantity__button--disabled":"hcr-quantity__button--disabled-1-6-0","hcr-quantity__button--minus":"hcr-quantity__button--minus-1-6-0","hcr-quantity__button--plus":"hcr-quantity__button--plus-1-6-0"}};

var bem = Bem('quantity', styles);
var Quantity = function Quantity(_ref) {
  var active = _ref.active,
      caption = _ref.caption,
      disabled = _ref.disabled,
      error = _ref.error,
      extraClasses = _ref.extraClasses,
      inline = _ref.inline,
      id = _ref.id,
      label = _ref.label,
      max = _ref.max,
      min = _ref.min,
      minusBtnProps = _ref.minusBtnProps,
      minusBtnTitle = _ref.minusBtnTitle,
      plusBtnProps = _ref.plusBtnProps,
      plusBtnTitle = _ref.plusBtnTitle,
      step = _ref.step,
      rest = _objectWithoutProperties(_ref, ["active", "caption", "disabled", "error", "extraClasses", "inline", "id", "label", "max", "min", "minusBtnProps", "minusBtnTitle", "plusBtnProps", "plusBtnTitle", "step"]);

  // refs
  var $plusBtn = null;
  var $minusBtn = null; // early assign to local variable val (computed input value)
  // used to properly setup button refs

  var val = _objectSpread2({}, rest).value || _objectSpread2({}, rest).defaultValue || ''; // disables buttons when reached or high/low boundary

  function updateBtns() {
    if ($minusBtn && !minusBtnProps.onClick) $minusBtn.disabled = val <= min === true;
    if ($plusBtn && !plusBtnProps.onClick) $plusBtn.disabled = val >= max === true;
  } // call updateBtns and triggers onChange prop (if present)


  function emitChange(e) {
    updateBtns();
    if (_objectSpread2({}, rest).onChange) _objectSpread2({}, rest).onChange(e);
  } // buttons click


  function click(e, type) {
    // traverse to get input
    var input = type === 'plus' ? e.target.previousSibling : e.target.nextSibling; // perform addition/subtraction

    val = input.value ? parseInt(input.value, 10) : 0;
    if (type === 'plus' && val < max) val += step;
    if (type === 'minus' && val > min) val -= step; // assing value

    input.value = val; // always assign the input value to the event target value
    // this allows consumers to get both, original (button || input )event && input value
    // therefore allowing state binding and updating to a single property

    e.target.value = input.value;
    emitChange(e);
  } // input keyup


  function keyUp(e) {
    // input field is empty nothing to do
    if (!e.target.value.length) {
      emitChange(e);
      return;
    } // check bounds


    val = e.target.value ? parseInt(e.target.value, 10) : '';
    if (val > max) e.target.value = max;
    if (val < min) e.target.value = min; // emit change event

    emitChange(e);
  }

  return React.createElement("div", {
    className: bem.b([{
      inline: inline
    }], extraClasses)
  }, React.createElement("label", {
    htmlFor: id,
    className: "".concat(bem.e('label'))
  }, label, caption && React.createElement("small", null, caption)), React.createElement("div", {
    className: bem.e('picker', {
      error: error,
      active: active,
      disabled: disabled
    })
  }, React.createElement("button", _extends({
    className: bem.e('button', 'minus'),
    disabled: disabled,
    onClick: function onClick(e) {
      click(e, 'minus');
    },
    ref: function ref(c) {
      $minusBtn = c;
      updateBtns();
    },
    title: minusBtnTitle,
    type: "button"
  }, minusBtnProps)), React.createElement("input", _extends({
    className: bem.e('input'),
    id: id,
    disabled: disabled,
    onKeyUp: keyUp,
    max: max,
    min: min,
    step: step,
    type: "number"
  }, rest)), React.createElement("button", _extends({
    className: bem.e('button', 'plus'),
    disabled: disabled,
    onClick: function onClick(e) {
      click(e, 'plus');
    },
    ref: function ref(c) {
      $plusBtn = c;
      updateBtns();
    },
    title: plusBtnTitle,
    type: "button"
  }, plusBtnProps))));
};
Quantity.displayName = 'Quantity';
Quantity.defaultProps = {
  active: false,
  caption: null,
  error: false,
  extraClasses: '',
  inline: false,
  max: 100,
  min: 0,
  minusBtnProps: {},
  minusBtnTitle: 'Remove',
  plusBtnProps: {},
  plusBtnTitle: 'Add',
  disabled: false,
  step: 1
};
Quantity.propTypes = {
  /** sets active state */
  active: PropTypes.bool,

  /** <small> caption text injected in <label> */
  caption: PropTypes.string,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Disables input and buttons */
  disabled: PropTypes.bool,

  /** sets error state */
  error: PropTypes.bool,

  /** Enforces label and input to appear in one line */
  inline: PropTypes.bool,

  /** Id for the input field, also used "for" label */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Provides label text, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref2) {
    var ariaLabel = _ref2['aria-label'],
        _label = _ref2.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** Maximum allowed value */
  max: PropTypes.number,

  /** Minimun allowed value */
  min: PropTypes.number,

  /** rest props for minus button  */
  minusBtnProps: PropTypes.object,
  // eslint-disable-line

  /** title for the minus button  */
  minusBtnTitle: PropTypes.string,

  /** rest props for plus button  */
  plusBtnProps: PropTypes.object,
  // eslint-disable-line

  /** title for the plus button */
  plusBtnTitle: PropTypes.string,

  /** Increment/decrement amount */
  step: PropTypes.number
};
var quantity = Injecss(Quantity, styles);

export { quantity as Quantity };
